import { State } from 'app/gamma/src/modules';

export const getCollapsedDrawerSections = (state: State) =>
  state.ui.collapsibles;
